import React, {useState} from 'react';

const EXAMPLES = {
  '+': {example: '1 + 2', result: '3', explanation: 'Addition'},
  '-': {example: '2 - 1', result: '1', explanation: 'Subtraction'},
  '*': {example: '3 * 1', result: '3', explanation: 'Multiplication'},
  '/': {example: '6 / 3', result: '2', explanation: 'Division'},
  '%': {example: '7 % 2', result: '1', explanation: 'Modulo'},
  '^': {example: '3^2', result: '9', explanation: 'Power'},
  '|': {example: '2 | 3 * 9', result: '27', explanation: 'Bitwise or'},
  '&': {example: '2 & 3 * 9', result: '2', explanation: 'Bitwise and'},
  '<<': {example: '1 << 3', result: '8', explanation: 'Bitwise left-shift'},
  '>>':{example: '40 >> 2', result: '10', explanation: 'Bitwise right-shift'},
  '<': {example: '1 < 2', result: 'true', explanation: 'less than'},
  '>': {example: '1 > 2', result: 'false', explanation: 'greater than'},
  '<=': {example: '1 <= 2', result: 'true', explanation: 'less than or equal'},
  '>=': {example: '1 >= 2', result: 'false', explanation: 'greater than or equal'},
  '<>': {example: '1 <> 2', result: 'true', explanation: 'less or greater than'},
  '!=': {example: '1 != 2', result: 'true', explanation: 'not equal'},
  '=': {example: '1 = 2', result: 'false', explanation: 'equal'},
  'IF': {example: "if(\"a\" < 5, 'Good', 'Bad')", result: null, explanation: 'if condition'},
  'AND': {example: 'and(\"a\",\"b\")', result: null, explanation: 'both exists'},
  'OR': {example: 'or(\"a\",\"b\")', result: null, explanation: 'at least one exists'},
  'XOR': {example: 'xor(\"a\",\"b\")', result: null, explanation: 'only one exists'},
  'NOT': {example: 'not(\"a\")', result: null, explanation: 'not'},
  'MIN': {example: 'min(\"a\",\"b\",\"c\")', result: null, explanation: 'smallest of n-values'},
  'MAX': {example: 'max(\"a\",\"b\",\"c\")', result: null, explanation: 'largest of n-values'},
  'SUM': {example: 'sum(\"a\",\"b\",\"c\")', result: null, explanation: 'sum of n-values'},
  'AVG': {example: 'avg(\"a\",\"b\",\"c\")', result: null, explanation: 'average of n-values'},
  'ROUND': {example: 'round(2.433,2)', result: '2.43', explanation: 'round value'},
  'ROUNDDOWN': {example: 'rounddown(2.433,2)', result: '2.43', explanation: 'round downwards'},
  'ROUNDUP': {example: 'round(2.433,2)', result: '2.44', explanation: 'round upwards'},
  'ABS': {example: 'abs(-1)', result: '1', explanation: 'absolute value'},
  'CASE': {example: "case \"fruit\"\n when 'apple' then 1 \n when 'banana' then 2 \n else 3 \n end", result: null, explanation: 'Map value by definition'},
  'LEFT': {example: "left('ABCD', 2)", result: 'AB', explanation: 'Take n characthers from left'},
  'RIGHT': {example: "right('ABCD', 2)", result: 'CD', explanation: 'Take n characthers from right'},
  'MID': {example: "mid('ABCD', 2, 2)", result: 'BC', explanation: 'Take n characters from starting position'},
  'LEN': {example: "len('ABCD')", result: 4, explanation: 'Length of string'},
  'FIND': {example: "find('BC', 'ABCD')", result: 2, explanation: 'Find position in string'},
  'SUBSTITUTE': {example: "substitute('ABCD', 'BC', 'XY')", result: 'AXYD', explanation: 'Substitute match'},
  'CONCAT': {example: "concat('a','b','c')", result: 'abc', explanation: 'Concatenate n strings'},
  'CONTAINS': {example: "contains('BC', 'ABCD')", result: 'true', explanation: 'Does second text contain the first'},
  'VAR': {example: "var(\"a\")", result: 2, explanation: 'Take programme static report variable'},
  'QUARTER': {example: 'QUARTER("2025-07-03")', result: 3, explanation: 'Extract the quarter of the year (1-4)'},
  'YEAR': {example: 'YEAR("2025-07-03")', result: 2025, explanation: 'Extract the year'},
  'MONTH': {example: 'MONTH("2025-07-03")', result: 7, explanation: 'Extract the month number of the year'},
  'WEEK': {example: 'WEEK("2025-07-03")', result: 26, explanation: 'Extract the week number of the year'},
  'HALF_YEAR': {example: 'HALF_YEAR("2025-07-03")', result: 2, explanation: 'Extract which half of the year (1 if in first half, 2 if in second half)'},
  'PAD_LEFT': {example: 'PAD_LEFT("hi", 6, "*")', result: "****hi", explanation: 'Pads a string on left to a certain length'},
  'PAD_RIGHT': {example: 'PAD_RIGHT("hi", 6, "*")', result: "hi****", explanation: 'Pads a string on right to a certain length'}
};


function C({children}){ // Code with example functinality
  const [showExample, setShowExample] = useState(false);

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setShowExample(pre => !pre);
  };

  if (showExample){
    return <p onClick={toggle} className='mt-1 mb-1' style={{borderLeft: '3px solid #CCC', paddingLeft: '0.5rem', cursor: 'pointer'}}>
      <code>{children}</code><br/>
      <b>{EXAMPLES[children]?.explanation}</b><br/>
      <code style={{whiteSpace: 'pre-wrap'}}>{EXAMPLES[children]?.example}</code> {EXAMPLES[children]?.result && <>results <code>{EXAMPLES[children]?.result}</code></>}
    </p>
  }

  return <code style={{cursor: 'pointer'}} onClick={toggle}>{children}</code>
};

export default C;
